import "babel-polyfill";
import "whatwg-fetch";
import 'url-search-params-polyfill';

import React, {useContext} from "react";
import {SearchContext} from "./SearchContext.js";
import { decodeHTML } from "../helpers.mjs";

const CreatorLink = ({key, creator, type, typeD, noLink=false}) => {
    
    const {doSearchTermSearch} = useContext(SearchContext);

    const creatorNameArray = decodeHTML(creator).split(",")
    let creatorText = "";
    if(creatorNameArray.length > 1) {
        creatorText = creatorNameArray[1] + " " + creatorNameArray[0];
    } else {
        creatorText = creator;
    }

    creatorText = creatorText.trim();

    if(noLink) {
        return <>
            {type != "other" && <span id={key}>{creatorText}{typeD != "Author" && <> ({typeD})</>}</span>}
            {type == "other" && <span id={key}>{creatorText}</span>}
        </>
    } else {
        return <>
            {type != "other" && <a href="#" onClick={e => {
                e.preventDefault();
                doSearchTermSearch(creator, type);
            }}>{creatorText}{typeD != "Author" && <> ({typeD})</>}</a>}
            {type == "other" && <span id={key}>{creatorText}</span>}
        </>
    }
}

export default CreatorLink;